import { render, staticRenderFns } from "./permissions-settings.vue?vue&type=template&id=0d9379a4"
import script from "./permissions-settings.vue?vue&type=script&lang=js"
export * from "./permissions-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports